class Builder {
  constructor(callback) {
    this.callback = callback;
  }

  build(args) {
    return this.callback(args);
  }
}

export default Builder;
